module.exports = __webpack_public_path__ + "static/img/b5.ad43362.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/hot/b5.png
// module id = vA6l
// module chunks = 0